import DOMPurify from 'dompurify';
import { neon } from '@/integrations/neon';

// Input sanitization utilities
export const sanitizeInput = (input: string): string => {
  return DOMPurify.sanitize(input, { 
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: []
  }).trim();
};

export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br'],
    ALLOWED_ATTR: []
  });
};

// Email validation
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  return emailRegex.test(email.trim());
};

// Input length validation
export const validateLength = (input: string, min: number, max: number): boolean => {
  const length = input.trim().length;
  return length >= min && length <= max;
};

// Generate cryptographically secure passwords (client-side fallback)
export const generateSecurePassword = (length: number = 20): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
  const firstChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  
  let result = firstChars.charAt(Math.floor(Math.random() * firstChars.length));
  
  for (let i = 1; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  
  return result;
};

// Security logging function
export const logSecurityEvent = async (action: string, details: Record<string, unknown> = {}) => {
  try {
    await neon.api.security.log(action, details);
  } catch (error) {
    console.error('Failed to log security event:', error);
  }
};
